import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchUserrequest } from './userrequestAPI'; // Assume this API function accepts filters as a parameter.

const initialState = {
  data: [],
  status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
};

// Async thunk to fetch data with filters
export const fetchUserrequestDataWithFilters = createAsyncThunk(
  'userrequest/fetchUserrequestDataWithFilters',
  async ({ filter = {}, options = {} }) => {
    const response = await fetchUserrequest({ filter, options }); // Pass filters to the API
    return response.data; // Assuming the API response contains a `data` field
  }
);

export const userrequestrSlice = createSlice({
  name: 'userrequest',
  initialState,
  reducers: {}, // No need for additional reducers in this simplified version
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserrequestDataWithFilters.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchUserrequestDataWithFilters.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload; // Store the fetched data
      })
      .addCase(fetchUserrequestDataWithFilters.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message; // Store error message
      });
  },
});

// Selector to access the data and status
export const selectUserrequestData = (state) => state.userrequest.data;
export const selectUserrequestStatus = (state) => state.userrequest.status;
export const selectUserrequestError = (state) => state.userrequest.error;

export default userrequestrSlice.reducer;
